import { createContext } from 'react';
export var UserOverrideContext = /*#__PURE__*/createContext({});
export var UserPermissionsOverrideContext = /*#__PURE__*/createContext({});
UserPermissionsOverrideContext.displayName = 'UserPermissionsOverrideContext';
export var UserContext = /*#__PURE__*/createContext(null);
UserContext.displayName = 'UserContext';
//# sourceMappingURL=UserContexts.js.map